module.exports = __webpack_public_path__ + "img/pick2.d006e489.png";